<template>
  <div class="stats-view-background" @click.self="$emit('close', $event)">
    <div class="stats-view">
      <div class="stats-header smooth-shadow">
        <icon size="18" class="mar-right-10">table_chart</icon>
        <h4>Statistic View</h4>
        <expand />
        <DecoupledDateFrequencyPicker
          :getSelectedTime="getSelectedTime"
          :getActiveTimeForDisplayViaProps="getActiveTimeForDisplayViaProps"
          :getActiveTimeWindow="getActiveTimeWindow"
          @saveTimeFilters="saveTimeFilters"
          :dropup="false"
        />
        <icon size="18" type="button" @click="$emit('close', $event)"
          >clear</icon
        >
      </div>
      <simplebar
        class="stats-container"
        data-simpleborders-gridar-auto-hide="false"
      >
        <div class="grid-heading">Orders</div>
        <div class="grid">
          <div class="overview-container">
            <div class="overview-card">
              <div>Total Orders</div>
              <div class="values">
                <div class="number">152.2K</div>
                <div class="percentage">+55.5%</div>
              </div>
            </div>
            <div class="overview-card">
              <div>Average Orders</div>
              <div class="values">
                <div class="number">15.5K</div>
                <div class="percentage">+55.5%</div>
              </div>
            </div>
          </div>
          <StatsCategoricalCard
            :totalCount="10000"
            title="Order Types"
            :data="[
              { name: 'B2B', count: 3555 },
              { name: 'B2C', count: 3423 },
            ]"
          />
          <StatsCategoricalCard
            :totalCount="1301"
            title="Order Categories"
            :data="[
              { name: 'Alpha', count: 355 },
              { name: 'Bravo', count: 523 },
              { name: 'Charli', count: 423 },
            ]"
          />
          <StatsCategoricalCard
            :totalCount="1000"
            title="Life Cycles"
            :data="[
              { name: 'Order Placed', count: 233 },
              { name: 'Order Picked Up', count: 423 },
              { name: 'Reached Destination', count: 765 },
              { name: 'Order Delivered', count: 23 },
            ]"
          />
          <!-- { name: 'Order Cancelled', count: 3423 }, -->
        </div>

        <div class="grid-heading">Riders</div>
        <div class="grid">
          <div class="overview-container">
            <div class="overview-card">
              <div>Idle Riders</div>
              <div class="values">
                <div class="number">15.5K</div>
                <div class="percentage">+55.5%</div>
              </div>
            </div>
            <div class="overview-card">
              <div>Idle Session Time</div>
              <div class="values">
                <div class="number">15.5K</div>
                <div class="percentage">+55.5%</div>
              </div>
            </div>
          </div>
          <StatsCategoricalCard
            :totalCount="1000"
            title="Life Cycles"
            :data="[
              { name: 'Order Placed', count: 233 },
              { name: 'Order Picked Up', count: 423 },
              { name: 'Reached Destination', count: 765 },
              { name: 'Order Delivered', count: 23 },
            ]"
          />
          <!-- <div class="distribution"> -->
          <!-- Distribution Chart -->
          <StatsDistribution
            :categories="categories"
            :combinedSeries="series"
          />
          <!-- </div> -->
        </div>
      </simplebar>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "@/lib/moment";
import DecoupledDateFrequencyPicker from "@/components/datetimepicker/DecoupledDateFrequencyPicker";
import StatsCategoricalCard from "@/components/supply_demand_gap/views/StatsCategoricalCard";
import StatsDistribution from "@/components/supply_demand_gap/views/StatsDistribution";

export default {
  components: {
    DecoupledDateFrequencyPicker,
    StatsCategoricalCard,
    StatsDistribution,
  },
  data() {
    return {
      categories: ["5km", "6km", "7km", "8km", "9km", "10km", "11km", "12km"],
      series: [
        {
          data: [620, 532, 956, 678, 281, 532, 563, 436],
          name: "Idle Rider ",
        },
        {
          data: [562, 936, 376, 170, 369, 592, 921, 274],
          name: "Active Rider",
        },
      ],
    };
  },
  computed: {
    // ...mapGetters("TimeManager", ["getActiveTimeWindow", "getActiveTimeSlice"]),
    ...mapGetters("Time", ["getActiveTimeWindow", "getActiveTimeSlice"]),
    getSelectedTime() {
      // Used for DecoupledDateFrequencyPicker
      if (this.getActiveTimeSlice && this.getActiveTimeSlice.t_start) {
        const { t_start, t_end } = this.getActiveTimeSlice;
        let startTime = moment(t_start * 1000).format("DD/MM/YY h:mm a");
        let endTime = moment(t_end * 1000).format("DD/MM/YY h:mm a");
        return `${startTime} to ${endTime}`;
      } else {
        return null;
      }
    },
    getActiveTimeForDisplayViaProps() {
      // Used for DecoupledDateFrequencyPicker
      if (this.getActiveTimeWindow && this.getActiveTimeWindow.length > 1) {
        const t_start = this.getActiveTimeWindow[0];
        const t_end = this.getActiveTimeWindow[1];
        let startTime = moment(t_start).format("DD/MM/YY h:mm a");
        let endTime = moment(t_end).format("DD/MM/YY h:mm a");
        return `${startTime} to ${endTime}`;
      } else {
        return null;
      }
    },
  },
  methods: {
    saveTimeFilters(timeFilters) {
      this.setActiveTimeWindow(timeFilters.selectedDate);
      this.setActiveDays(timeFilters.selectedDays);
      this.setActivePeaks(timeFilters.selectedPeaks);
      // Toggle Change time
      this.refetchAllWidgets();
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.stats-view-background {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: var(--popup-background-color);
  display: flex;

  .stats-view {
    width: 90%;
    max-width: 1400px;
    margin: 15px auto 15px auto;
    align-self: stretch;
    background: var(--color-default-background);
    border-radius: 5px 5px 0 0;
    display: flex;
    flex-direction: column;

    .stats-header {
      background: var(--color-secondary);
      padding: 10px 10px 10px 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 5px 5px 0 0;
    }

    .stats-container {
      flex: 1;
      min-height: 5px;
      padding: 15px;
      /* background: gray; */

      .grid-heading {
        font-size: 1.2em;
        margin: 15px 0;

        &:first-child {
          margin-top: 0;
        }
      }

      .grid {
        display: grid;
        grid-template-columns: 260px 1fr 1fr 1fr;
        grid-template-rows: 250px;
        gap: 15px;

        div {
          /* background: var(--color-secondary); */
          border-radius: 5px;
          /* padding: 15px; */
        }

        .distribution {
          grid-column-start: 3;
          grid-column-end: 5;
        }

        .overview-container {
          display: grid;
          grid-template-columns: 1;
          gap: 15px;

          .overview-card {
            background: var(--color-secondary);
            padding: 15px;
            display: flex;
            flex-direction: column;

            .values {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .number {
                font-size: 1.8em;
              }

              .percentage {
                font-size: 1.4em;
              }
            }
          }
        }
      }
    }
  }
}
</style>
